import { ActivitySchedule, ActivityDefinition, ActivityReservation } from '../../../model/activities';

export interface IState {
    schedules: ActivitySchedule[];
    reservations: ActivityReservation[];
    isLoading: boolean;
    isLoadingReservations: boolean;
    allActivities: ActivityDefinition[];
    isLoadingDetails: boolean;
}

export const DefaultState = (): IState => ({
    schedules: [],
    allActivities: [],
    isLoading: false,
    isLoadingDetails: false,
    isLoadingReservations: false,
    reservations: []
})